/**
 * LRU helpers para caché multi-modelo Whisper (testeable; espejo del worker).
 */

/**
 * @param {string[]} lruOrder
 * @param {string} modelId
 * @returns {string[]}
 */
export function touchLruOrder(lruOrder, modelId) {
  const next = lruOrder.filter((id) => id !== modelId)
  next.push(modelId)
  return next
}

/**
 * @param {Map<string, unknown>} cache
 * @param {string[]} lruOrder
 * @param {number} maxSize
 * @returns {{ cache: Map<string, unknown>, lruOrder: string[] }}
 */
export function evictLruIfNeeded(cache, lruOrder, maxSize) {
  const nextCache = new Map(cache)
  const nextOrder = lruOrder.slice()
  while (nextCache.size > maxSize && nextOrder.length > 0) {
    const oldest = nextOrder.shift()
    if (oldest && nextCache.has(oldest)) {
      nextCache.delete(oldest)
    }
  }
  return { cache: nextCache, lruOrder: nextOrder }
}

/**
 * @param {object} [info]
 * @returns {{ phase: string, fromCache: boolean }}
 */
export function mapWhisperProgressPhase(info) {
  const status = String((info && info.status) || 'progress').toLowerCase()
  if (status === 'download') {
    return { phase: 'download', fromCache: false }
  }
  if (status === 'progress' || status === 'init') {
    return { phase: 'init', fromCache: true }
  }
  if (status === 'ready' || status === 'done') {
    return { phase: 'ready', fromCache: true }
  }
  return { phase: status, fromCache: false }
}

/**
 * @param {object} [progress]
 * @returns {{ message: string, percent: number|null }}
 */
export function mapSttProgressToUi(progress) {
  if (!progress) {
    return { message: 'Cargando modelo Whisper…', percent: null }
  }
  const pct =
    typeof progress.progress === 'number'
      ? progress.progress * (progress.progress <= 1 ? 100 : 1)
      : null

  if (progress.phase === 'ready' && progress.fromCache) {
    return { message: 'Modelo listo (en memoria)', percent: 100 }
  }
  if (progress.fromCache || progress.phase === 'init') {
    const file = progress.file ? ` ${progress.file}` : ''
    return {
      message: `Cargando modelo desde caché${file}…`,
      percent: pct,
    }
  }
  if (progress.phase === 'download' || progress.status === 'download') {
    const file = progress.file ? ` ${progress.file}` : ''
    return {
      message: `Descargando${file}…`,
      percent: pct,
    }
  }
  return {
    message: progress.file
      ? `Cargando ${progress.file}…`
      : 'Cargando modelo Whisper…',
    percent: pct,
  }
}

/**
 * @param {string} modelId
 * @returns {string}
 */
export function formatWhisperModelShort(modelId) {
  if (!modelId) return ''
  const m = String(modelId).match(/whisper-([\w.]+)/i)
  return m ? m[1] : String(modelId).split('/').pop() || modelId
}

export default {
  touchLruOrder,
  evictLruIfNeeded,
  mapWhisperProgressPhase,
  mapSttProgressToUi,
}
